import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email) {
      setSubscribed(true);
      setEmail('');
      setTimeout(() => setSubscribed(false), 3000);
    }
  };

  return (
    <footer className="bg-charcoal text-gallery py-16 mt-auto">
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          <div className="md:col-span-2">
            <h3 className="font-serif text-2xl mb-4 text-white">FrameFoundry</h3>
            <p className="text-gray-400 max-w-sm mb-6 leading-relaxed">
              Curated wall art and bespoke framing for the modern collector. Elevate your space with museum-quality prints.
            </p>
            <form onSubmit={handleSubscribe} className="flex flex-col sm:flex-row gap-2 max-w-md">
              <label htmlFor="newsletter-email" className="sr-only">Email address</label>
              <input 
                id="newsletter-email"
                type="email" 
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Join our newsletter" 
                required
                className="bg-transparent border border-gray-600 px-4 py-3 min-h-[44px] w-full focus:outline-none focus:border-white focus:ring-1 focus:ring-white transition-colors text-white rounded-sm placeholder:text-gray-500"
              />
              <button 
                type="submit" 
                className="bg-white text-charcoal px-6 py-3 min-h-[44px] font-bold uppercase tracking-widest text-[11px] hover:bg-gray-200 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-charcoal rounded-sm whitespace-nowrap"
              >
                {subscribed ? 'Subscribed!' : 'Subscribe'}
              </button>
            </form>
          </div>
          
          <div>
            <h4 className="font-bold text-white mb-6 uppercase tracking-[0.2em] text-[11px]">Portfolio</h4>
            <ul className="space-y-4 text-sm text-gray-400">
              <li><Link to="/shop" className="hover:text-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white rounded-sm px-1 -ml-1 inline-block">All Prints</Link></li>
              <li><Link to="/shop" className="hover:text-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white rounded-sm px-1 -ml-1 inline-block">New Arrivals</Link></li>
              <li><Link to="/shop" className="hover:text-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white rounded-sm px-1 -ml-1 inline-block">Bestsellers</Link></li>
              <li><Link to="/info" className="hover:text-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white rounded-sm px-1 -ml-1 inline-block">Framing Guide</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-white mb-6 uppercase tracking-[0.2em] text-[11px]">Support</h4>
            <ul className="space-y-4 text-sm text-gray-400">
              <li><Link to="/info" className="hover:text-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white rounded-sm px-1 -ml-1 inline-block">FAQ</Link></li>
              <li><Link to="/info" className="hover:text-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white rounded-sm px-1 -ml-1 inline-block">Shipping & Returns</Link></li>
              <li><a href="#" className="hover:text-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white rounded-sm px-1 -ml-1 inline-block">Contact Us</a></li>
              <li><a href="#" className="hover:text-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white rounded-sm px-1 -ml-1 inline-block">Trade Program</a></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-700 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-500">
          <p>&copy; {new Date().getFullYear()} FrameFoundry Prints. All rights reserved.</p>
          <p className="text-center" style={{ textTransform: 'none' }}><span>Made by </span><a href="https://diglab.ai/" target="_blank" rel="noopener noreferrer" style={{ textTransform: 'none' }}>DigLab.ai</a><span> and </span><a href="https://linglinkai.cn/" target="_blank" rel="noopener noreferrer" style={{ textTransform: 'none' }}>LingLinkAI.cn</a></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;